import { SxProps } from "@mui/material";
import React from 'react'
import SubmitButton from "../../components/SubmitButton";

interface Props {
  title: string;
  disabled?: boolean;
  sx?: SxProps;
  validate: () => Promise<boolean>;
  onSubmit: () => Promise<boolean>;
}

const CreateUpdateButton: React.FC<Props> = ({ title, disabled, sx, validate, onSubmit }) => {
  return (
    <SubmitButton
      size={"small"}
      variant="contained"
      style={styles.tableCreateBtn}
      sx={sx}
      disabled={disabled}
      onSubmit={onSubmit}
      validate={validate}
    >
      <span style={styles.tableCreateBtnTxt}>
        {title}
      </span>
    </SubmitButton>
  );
}
export default CreateUpdateButton

const styles = {
  tableCreateBtn: {
    alignSelf: "center",
    borderRadius: 20,
    marginTop: 30,
    marginBottom: 20,
    minWidth: 100,
  },
  tableCreateBtnTxt: {
    fontWeight: "400",
    color: "#ffffff",
    fontSize: 14,
    whiteSpace: "nowrap",
  },
}
